import React,{ useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button,Card,Form,Container,Row,Col} 
from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit,faDeleteLeft} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import { useFichaConsultante } from 'hooks/useFichaConsultante';
import {MensajeAlerta} from '../Messages/MensajeAlerta';
import Select from 'react-select'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import 'moment/locale/es';

const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}
function ListadoSesionesFicha(){
    const parametros = useParams();
    const { sesionesFicha, 
        getSesionesPorConsultante,
        getUsuariosTerapeutasOcupacionales,
        getUsuariosPsicologas,
        getUsuariosOtros,
        usuariosTo,
        usuariosSicologas,
        usuariosOtros,
        insertSesion,
        respuestaIngresoSesion,
        updateRespuestaIngresoSesion,
        deleteFichaConsultanteSesion
    
        } = useFichaConsultante({Id:parametros.id});
        
        const [isChangedElements,setChange]=useState(false);
        let opcionesSelectorTO=[];
        let opcionesSelectorPsicologas=[];
        let opcionesSelectorOtros=[];
        const [sesionPorIngresar, setSesionPorIngresar] = useState({});
   
        const columnas=[
    {
        name:'Id',
        selector: row => row.Id,
        sorteable:true,
        omit:true
    },
    {
        name:'Fecha Sesión',
        selector: row => moment.utc(row.FechaSesion).format('DD/MM/YYYY HH:mm:ss'),
        sorteable:true,
        render: function (data, type, row, meta) {
            console.log('aloha')
            return moment.utc(data).local().format('DD/MM/YYYY HH:mm:ss');
        }
    },
    {
        name:'Comentarios',
        selector: row => row.Comentario,
        sorteable:true
    },
    {
        cell: row => (
            <>
            <a href={'../EditarSesion/'+row.Id} rel="noopener noreferrer">
            	<FontAwesomeIcon icon={faEdit} />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href="#" onClick={event=>onDelete(row.Id)} rel="noopener noreferrer" title='Eliminar'>
            	<FontAwesomeIcon icon={faDeleteLeft} />
            </a>
           
            </>       
        ),
    }
    
        ];
            const onChangeSesion= (event,prop) => {
                if(event._isAMomentObject)
                {
                    setSesionPorIngresar({...sesionPorIngresar,['LSFFechaSesionGTM']:event._d});
                }
                else
                {
                    if(Array.isArray(event)){
                        let valorArreglo=[];
                        for(var i=0;i<event.length;i++){
                            valorArreglo.push(event[i].value)
                        }
                        const propiedad=prop.name?.replace('Name','')
                        setSesionPorIngresar({...sesionPorIngresar,[propiedad]:valorArreglo});
                    }
                    else
                    {
                        let valor=event.target.value;
                        const nombre=event.target.name?.replace('Name','')
                        if(nombre=='LSFComentarios'){
                            valor=valor.slice(0, 4000);
                            setSesionPorIngresar({...sesionPorIngresar,[nombre]:valor});
                        }
                        else{
                            setSesionPorIngresar({...sesionPorIngresar,[nombre]:valor});
                        }

                        
                    }
                }
            }

            const crearSesion = async() => {
                setChange(false);
                const resp=await insertSesion(sesionPorIngresar);
                if(resp.success)
                {
                    setSesionPorIngresar({'LSFComentarios':''});
                    setChange(true);
                }
            };
            const eliminarSesion= async(id) => {
                setChange(false);
                const resp=await deleteFichaConsultanteSesion(id);
                if(resp.success)
                {
                    setChange(true);
                }
            };
    const onDelete=async n=>{
    
        confirmAlert({
            title: '',
            message: '¿Seguro desea eliminar sesión?',
            buttons: [
              {
                label: 'Si',
                onClick: () => {
                    eliminarSesion(n)
                }
              },
              {
                label: 'No'
                
              }
            ]
          });
    
    }
  
    useEffect( () => {
       async function setSesionesFuncion(){
        await getSesionesPorConsultante();
        await getUsuariosTerapeutasOcupacionales();  
        await getUsuariosPsicologas();  
        await getUsuariosOtros();
        await updateRespuestaIngresoSesion();   

       }
       setSesionesFuncion();
        
        
    }, [isChangedElements]);
    
    usuariosTo?.map((elem)=>{
        opcionesSelectorTO.push(
              {
                  value:elem.Usuario,
                  label:elem.NombreSocial 
                }
          )
    });
    usuariosSicologas?.map((elem)=>{
        opcionesSelectorPsicologas.push(
              {
                  value:elem.Usuario,
                  label:elem.NombreSocial 
                }
          )
    });
    usuariosOtros?.map((elem)=>{
        opcionesSelectorOtros.push(
              {
                  value:elem.Usuario,
                  label:elem.NombreSocial 
                }
          )
    });
        return (
            <>
             <Container fluid>
             <Tabs
              defaultActiveKey="1"
              id="uncontrolled-tab-example"
              className="mb-3">   
                <Tab eventKey={1} title={'Listado Sesiones'}>
                    {/*<Form>*/}
                    <Row>
                    <Col>
                    <div className='table-responsive'>
                    <DataTable
                    columns={columnas}
                    data={sesionesFicha}
                    pagination
                    paginationComponentOptions={paginacionOpciones}
                    fixedHeader
                    fixedHeaderScrollHeight='600px'
                    noDataComponent="No hay elementos para mostrar"
                    striped={true}
                   
                />
                    </div>

                    </Col>
                    </Row>
                {/*</Form>*/}
                </Tab>
                <Tab eventKey={2} title={'Agregar Sesión'}>
                    {/*<Form>*/}
                    <Row>
                    <Col xs="6">
                    <label>Profesionales Psicóloga</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        name="LSFSicologas"
                        options={opcionesSelectorPsicologas}
                        //value={sesionPorIngresar?.LSFSicologas}
                        value={opcionesSelectorPsicologas.filter(item => sesionPorIngresar?.LSFSicologas?.includes(item.value))}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={ onChangeSesion}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Profesionales TO</label>
                        <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        name="LSFTO"
                        options={opcionesSelectorTO}
                        value={opcionesSelectorTO.filter(item => sesionPorIngresar?.LSFTO?.includes(item.value))}
                        
                        className="basic-multi-select"
                        classNamePrefix="select"
                       
                        onChange={ (e,prop) => { onChangeSesion(e,prop) }}
                        
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="6">
                    <label>Profesionales Otros</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        name={'LSFOtros'}
                        options={opcionesSelectorOtros}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={opcionesSelectorOtros.filter(item => sesionPorIngresar?.LSFOtros?.includes(item.value))}
                        onChange={ (e,prop) => { onChangeSesion(e,prop) }}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Fecha Sesión (Hora Santiago,Chile)</label>
                        <Datetime
                            onChange={onChangeSesion}
                            name={'LSFFechaSesionGTM'}
                            value={sesionPorIngresar?.LSFFechaSesionGTM}
                            utc={true}
                            
                        ></Datetime>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                 
                    <label>Comentarios</label>
                    <Form.Control
                        name="LSFComentarios"
                        value={sesionPorIngresar?.LSFComentarios}
                        placeholder=""
                        type="textarea"
                        as="textarea"
                        onChange={onChangeSesion}
                        maxLength={4000}
                        rows={12}>
                    </Form.Control>
                    <div style={{ textAlign: 'right', marginTop: 4, color: '#666' }}>
                        {sesionPorIngresar?.LSFComentarios?.length} / {4000}
                    </div>
                   
                    </Col>
                   
                </Row>
                <MensajeAlerta mensajeTexto={respuestaIngresoSesion.mensajeTexto} estado={respuestaIngresoSesion.estado} />
                <Row>
                    <Col xs="6">
                    </Col>
                    <Col xs="6">
                 
                    <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                        onClick={(e)=>{
                            e.preventDefault();
                            crearSesion();
                     
                        }}
                      >
                    Ingresar Sesión
                  </Button>
                   
                    </Col>
                   
                </Row>

                    {/*</Form>*/}
                </Tab>
            </Tabs>
            </Container>
            </>
        )
}
export default ListadoSesionesFicha;